import { API, Designer, Lang, Team, TeamAPI } from "@brg/api";
import { FC, useEffect, useMemo, useRef, useState } from "react";
import { ArchiveLabel, Container, DropdownWrapper, LeftSideContaner, Link, ListItem, RightSideContaner, SvgWrapper, SwitcherItem } from "./styles";
import { Colors, Dropdown, Skeleton, useBreakpoint } from "@brg/ui";
import ArrowTopIconWithText from "shared/icons/ArrowTopIconWithText";
import { ApprovedIcon } from "shared/icons/ApprovedIcon";
import { OPTION_TYPE } from "@brg/ui/dist/types/ui-input/types";
import { TeamStatusActiveArchived } from "shared/helpers/teamsStatus";
import { isTeamChannel, ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { useHistory } from "react-router-dom";
import { LayoutConst } from "core";
import { useTranslation } from "react-i18next";
import { LinkTo } from "shared/constants/linkTo";
import { useProfile } from "@brg/auth";
import { OwnersList } from "./components/OwnersList";

enum TABS {
    media = 'media',
    feed = 'feed'
}

export const ChannelsInfo: FC<{ 
    team?: Team<'Local'>,
    isFeed?: boolean, 
    onToggle: (flag: boolean) => void }> = ({ team, isFeed, onToggle }) => {
    const { t, i18n: { language }} = useTranslation();
    const profile = useProfile();
    const [loading, setIsLoading] = useState(false);
    const [currentTab, setCurrentTab] = useState<any>(TABS.media);

    const {isChannel, channelType} = isTeamChannel(team?.moderationType ?? ModerationType.Channel)

    const onChange = (tab: TABS) => {
        setCurrentTab(tab)
        onToggle(tab === TABS.feed)
    }

    const {mainOwner, owners} = useMemo(() => {
        return {
            mainOwner: team?.owners?.[0],
            owners: team?.owners
        }
    } , [team])

    const tabsHidden = useMemo(() => {
        return channelType !== ModerationType.Channel;
    } , [mainOwner, profile, channelType])

    const hasTeamEmblem = useMemo(
        //@ts-ignore
        () => ((!!team?.titleImages?.length && !!team?.isShowTeamEmblem))
    , [team]);

    const shouldDisplayArchiveEmblem = useMemo(() => {
        return !hasTeamEmblem && !!TeamStatusActiveArchived(team)
    }, [hasTeamEmblem]);


    const archiveLabel = useMemo(() => {
        if (!shouldDisplayArchiveEmblem) return null

        return (
            <RightSideContaner>
                <ArchiveLabel>{t('subscription.in_archive')}</ArchiveLabel>
            </RightSideContaner>
        )
    } , [shouldDisplayArchiveEmblem])

    const switcher = useMemo(() => {
        if (tabsHidden) return null;
        return (
            <>
                <SwitcherItem isActive={!isFeed} onClick={() => onChange(TABS.media)}>{t('subscription.media')}</SwitcherItem>
                <SwitcherItem isActive={!!isFeed} onClick={() =>onChange(TABS.feed)}>{t('subscription.feed_page')}</SwitcherItem>
            </>
        )
    } , [currentTab, isFeed, language])

    const ownersLinks = useMemo(() => {
        return <OwnersList 
            owners={(owners || []) as Designer[]}
        />
    } , [owners, language])

    if (loading) {
        return (
            <Skeleton width={180} height={24} />
        )
    }

    return (
        <Container>
            <LeftSideContaner gx={24}>
                {ownersLinks}
                {switcher}
            </LeftSideContaner>
            {archiveLabel}
        </Container>
    )
}import { API, Designer, Lang, Team, TeamAPI } from "@brg/api";
import { FC, useEffect, useMemo, useRef, useState } from "react";
import { ArchiveLabel, Container, DropdownWrapper, LeftSideContaner, Link, ListItem, RightSideContaner, SvgWrapper, SwitcherItem } from "./styles";
import { Colors, Dropdown, Skeleton, useBreakpoint } from "@brg/ui";
import ArrowTopIconWithText from "shared/icons/ArrowTopIconWithText";
import { ApprovedIcon } from "shared/icons/ApprovedIcon";
import { OPTION_TYPE } from "@brg/ui/dist/types/ui-input/types";
import { TeamStatusActiveArchived } from "shared/helpers/teamsStatus";
import { isTeamChannel, ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { useHistory } from "react-router-dom";
import { LayoutConst } from "core";
import { useTranslation } from "react-i18next";
import { LinkTo } from "shared/constants/linkTo";
import { useProfile } from "@brg/auth";
import { OwnersList } from "./components/OwnersList";

enum TABS {
    media = 'media',
    feed = 'feed'
}

export const ChannelsInfo: FC<{ 
    team?: Team<'Local'>,
    isFeed?: boolean, 
    onToggle: (flag: boolean) => void }> = ({ team, isFeed, onToggle }) => {
    const { t, i18n: { language }} = useTranslation();
    const profile = useProfile();
    const [loading, setIsLoading] = useState(false);
    const [currentTab, setCurrentTab] = useState<any>(TABS.media);

    const {isChannel, channelType} = isTeamChannel(team?.moderationType ?? ModerationType.Channel)

    const onChange = (tab: TABS) => {
        setCurrentTab(tab)
        onToggle(tab === TABS.feed)
    }

    const {mainOwner, owners} = useMemo(() => {
        return {
            mainOwner: team?.owners?.[0],
            owners: team?.owners
        }
    } , [team])

    const tabsHidden = useMemo(() => {
        return channelType !== ModerationType.Channel;
    } , [mainOwner, profile, channelType])

    const hasTeamEmblem = useMemo(
        //@ts-ignore
        () => ((!!team?.titleImages?.length && !!team?.isShowTeamEmblem))
    , [team]);

    const shouldDisplayArchiveEmblem = useMemo(() => {
        return !hasTeamEmblem && !!TeamStatusActiveArchived(team)
    }, [hasTeamEmblem]);


    const archiveLabel = useMemo(() => {
        if (!shouldDisplayArchiveEmblem) return null

        return (
            <RightSideContaner>
                <ArchiveLabel>{t('subscription.in_archive')}</ArchiveLabel>
            </RightSideContaner>
        )
    } , [shouldDisplayArchiveEmblem])

    const switcher = useMemo(() => {
        if (tabsHidden) return null;
        return (
            <>
                <SwitcherItem isActive={!isFeed} onClick={() => onChange(TABS.media)}>{t('subscription.media')}</SwitcherItem>
                <SwitcherItem isActive={!!isFeed} onClick={() =>onChange(TABS.feed)}>{t('subscription.feed_page')}</SwitcherItem>
            </>
        )
    } , [currentTab, isFeed, language])

    const ownersLinks = useMemo(() => {
        return <OwnersList 
            owners={(owners || []) as Designer[]}
        />
    } , [owners, language])

    if (loading) {
        return (
            <Skeleton width={180} height={24} />
        )
    }

    return (
        <Container>
            <LeftSideContaner gx={24}>
                {ownersLinks}
                {switcher}
            </LeftSideContaner>
            {archiveLabel}
        </Container>
    )
}